import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useVerifyMfaMutation } from "../../hooks/queries/useAuthQueries";
import { toastService } from "../../providers";
import { extractAxiosErrorMessage } from "../../services/utils/errorUtils";
import { otpValidator } from "../../lib/validations/authValidations";
import useAuthStore from "../../stores/authStore";
import AuthLayout from "../../components/auth/authLayout/AuthLayout";
import AuthCard from "../../components/auth/authCard/AuthCard";
import { CustomPinInput } from "../../components/ui/CustomPin/CustomPin";
import { CustomText } from "../../components/ui/CustomText/CustomText";
import CustomButton from "../../components/ui/CustomButton/CustomButton";

const OTPVerification = () => {
  const navigate = useNavigate();
  const { mutate: verifyMfaMutation, isPending } = useVerifyMfaMutation();
  const { setTokens, clearTempEmail } = useAuthStore();

  const { control, handleSubmit } = useForm({
    defaultValues: { otp: "" },
    mode: "onTouched",
  });

  const onSubmit = (values) => {
    verifyMfaMutation(values.otp, {
      onSuccess: (data) => {
        if (data.accessToken && data.refreshToken) {
          setTokens(data.accessToken, data.refreshToken);
        }
        clearTempEmail();
        toastService.success("OTP verified successfully");
        navigate("/dashboard");
      },
      onError: (error) => {
        toastService.error(
          extractAxiosErrorMessage(error, "MFA verification failed.")
        );
      },
    });
  };

  return (
    <AuthLayout>
      <AuthCard
        subtitle={
          <div className="text-black-50 text-xs sm:text-[15px]">
            Enter the 6-digit code sent via SMS to your registered mobile number
          </div>
        }
      >
        <form
          className="flex flex-col gap-2.5 sm:gap-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Controller
            name="otp"
            control={control}
            rules={{ validate: (v) => otpValidator(v) ?? true }}
            render={({ field, fieldState }) => (
              <>
                <CustomPinInput
                  length={6}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  disabled={isPending}
                />
                {fieldState.error && (
                  <CustomText c="error" size="sm" align="center">
                    {fieldState.error.message}
                  </CustomText>
                )}
              </>
            )}
          />
          <CustomButton
            type="submit"
            radius="xl"
            size="md"
            fullWidth
            disabled={isPending}
            loading={isPending}
          >
            Submit
          </CustomButton>
          <div className="grid grid-cols-1 gap-2 mt-2 text-xs sm:text-sm text-neutral-500 sm:flex sm:items-center sm:justify-between">
            <p className="text-sm">Didn't receive code?&nbsp;</p>
            <CustomButton
              type="button"
              size="sm"
              fullWidth={false}
              disabled={true}
              title="Feature coming soon"
            >
              Resend code
            </CustomButton>
          </div>
        </form>
      </AuthCard>
    </AuthLayout>
  );
};

export default OTPVerification;
